import { jsx as _jsx } from "react/jsx-runtime";
import { BadgeFromSpec } from '../primitives/Badge.js';
import { coverageSpec, gateSpec, severitySpec, statusSpec, watchSpec, } from '../internal/variants.js';
/**
 * Core lifecycle / coverage / decision badges. Each is a thin wrapper over the shared
 * Badge primitive driven by a pure spec function in `internal/variants`, so the
 * state→tone mapping is testable without a renderer.
 */
/** StatusBadge — rule lifecycle (core.css badges): published / in_review / draft / superseded / retired. */
export function StatusBadge({ status }) {
    return _jsx(BadgeFromSpec, { spec: statusSpec(status) });
}
/** CoverageBadge — coverage cell state: covered / thin / empty. */
export function CoverageBadge({ state }) {
    return _jsx(BadgeFromSpec, { spec: coverageSpec(state) });
}
/** GateBadge — serving decision: answer (pass) / abstain (amber). */
export function GateBadge({ gate }) {
    return _jsx(BadgeFromSpec, { spec: gateSpec(gate) });
}
/** WatchBadge — source-of-law watch state: stable / monitoring / changed. */
export function WatchBadge({ state }) {
    return _jsx(BadgeFromSpec, { spec: watchSpec(state) });
}
/** SeverityBadge — flag severity: low / medium / high / blocking. */
export function SeverityBadge({ severity }) {
    return _jsx(BadgeFromSpec, { spec: severitySpec(severity) });
}
//# sourceMappingURL=Badges.js.map